import { gql } from '@apollo/client';

export const CANCEL_EVENT_REQUEST = gql`
  mutation cancelRequest($requestId: String!, $reason: String!) {
    cancelEventRequest(requestId: $requestId, reason: $reason) {
      complete
    }
  }
`;
